import Vue from 'vue'
import http from '@/fetch/http'
import * as types  from '@/vuex/types'
import util from '@/utils'

const state = {
  //试题列表
  exerciseTypeList: [],
  //试卷库列表
  paperList: [],
  //分数列表
  numScoreList: [],
  //试题总数
  exerciseNum: 0,
  //试题总分
  exerciseScore: 0,
  //课程下试卷列表
  examPaperList: [],
  pageNo: 1,
  pageSize: 12,
  paperName: ''
}

const actions = {
  /**
   * 根据试卷id查询试题列表
   * @param commit
   * @param id
   */
  selectExerciseByPaperId({commit}, id){
    let param = {
      paperId: id
    }
    http.selectExerciseByPaperId(param).then(res => {
      if (res.msgCode == types.STATUS_OK) {
        commit("SET_EXERCISE_LIST", res.data);
      }
    })
  },

  /**
   * 根据题库id查询试题数量和分数
   * @param commit
   * @param id
   */
  selectExercisesNumAndScore({commit}, id){
    let param = {
      paperId: id
    }
    http.selectExercisesNumAndScore(param).then(res => {
      if (res.msgCode == types.STATUS_OK) {
        let score = 0;
        let num = 0;
        for (let i = 0; i < res.data.length; i++) {
          score += res.data[i].sumScore;
          num += res.data[i].exercisesNum;
        }
        commit("SET_NUMSCORE_LIST", res.data);
        commit("SET_EXERCISE_SCORE", score);
        commit("SET_EXERCISE_NUM", num);
      }
    });
  },

  /**
   * 移动试题
   * @param commit
   * @param param
   */
  moveExercise({commit}, param){
    http.moveExerciseInPaper(param).then(res => {
      if (res.msgCode == types.STATUS_OK) {
        param.success(param);
      }
    });
  },
  /**
   * 移除试卷中的试题
   * @param commit
   * @param param
   */
  deleteExercise({commit}, param){
    http.deleteExerciseInPaper(param).then(res => {
      if (res.msgCode == types.STATUS_OK) {
        param.success(param);
      }
    });
  },
  /**
   * 移除试卷中一类试题
   * @param commit
   * @param param
   */
  deleteExerciseTypeInPaper({commit}, param){
    http.deleteExerciseTypeInPaper(param).then(res => {
      if (res.msgCode == types.STATUS_OK) {
        param.success(param);
      }
    });
  },
  /**
   * 查询课程下的试卷列表
   * @param commit
   * @param param
   */
  getMyEPList({commit}, param){
    http.getMyEPList(param).then(res => {
      if (res.msgCode == types.STATUS_OK) {
        commit("SET_EXAMPAPER_LIST", res.data);
      }
    });
  },

  /**
   * 试卷设定一道题分数
   * @param commit
   * @param param
   */
  updateScoreInPaper({commit}, param){
    http.updateScoreInPaper(param).then(res => {
      if (res.msgCode == types.STATUS_OK) {
        param.updateSocreSuccess(param);
      }
    });
  },
  /**
   * 试卷批量设定分数
   * @param commit
   * @param param
   */
  updateTypeScoreInPaper({commit}, param){
    http.updateTypeScoreInPaper(param).then(res => {
      if (res.msgCode == types.STATUS_OK) {
        param.updateSocreSuccess(param);
      }
    });
  },
  // 设定试卷名称
  setPaperNameByPaperId({commit}, param) {
    http.selectPaper({examPaperId: param.paperId}).then(res => {
      if (res.msgCode == types.STATUS_OK) {
        commit("SET_PAPER_NAME", res.data.name);
      }
    });
  },
  // 设定试卷名称
  setPaperName({commit}, param) {
	  commit("SET_PAPER_NAME", param);
  }
}

const getters = {}

const mutations = {
  ['SET_PAPER_NAME'](state, param) {
    Vue.set(state, 'paperName', param);
  },
  ['SET_EXERCISE_LIST'](state, list) {
    Vue.set(state, 'exerciseTypeList', list);
  },
  ['SET_NUMSCORE_LIST'](state, list) {
    Vue.set(state, 'numScoreList', list);
  },
  ['SET_EXERCISE_NUM'](state, num) {
    Vue.set(state, 'exerciseNum', num);
  },
  ['SET_EXERCISE_SCORE'](state, score) {
    Vue.set(state, 'exerciseScore', score);
  },
  ['SET_EXAMPAPER_LIST'](state, list) {
    Vue.set(state, 'examPaperList', list);
  }
}

export default {
  state,
  actions,
  getters,
  mutations
}



// WEBPACK FOOTER //
// ./src/vuex/modules/paperlibraryview.js